export class SetFileDto {
  fileId: string
}

export class SetFilesDto {
  fileIds: string[]
}